import styled from 'styled-components';
import { FuelIcon } from '@frete.com/fuel-react';

export const List = styled.ul`
  align-items: center;
  display: flex;
  list-style-type: none;
  padding-left: ${({ theme }) => theme.spacing.km0};

  justify-content: space-between;
  flex-wrap: wrap;
`;

export const Item = styled.li`
  align-items: center;
  display: flex;
  font-size: ${({ theme }) => theme.font.size.m1};
  line-height: ${({ theme }) => theme.spacing.km8};
  text-transform: uppercase;
  width: 33%;

  @media (max-width: ${({ theme }) => theme.breakpoint.md.maxWidth}) {
    width: 50%;
  }
`;

export const Icon = styled(FuelIcon)`
  color: ${({ theme }) => theme.color.background.success.strong};
  margin-right: 10px;
  width: 12px;
`;
